import { COLORS } from '../theme/colors';

export const API_BASE = process.env.REACT_APP_API_URL || 'https://alphatnc-5138977eb927.herokuapp.com';
export const CARD_SX = { bgcolor: COLORS.overlay, borderRadius: 2, boxShadow: 3 };
